window.okeReviewsWidgetOnInit = function () {
    setupAggregate();
    moveWarButton();

    // Mutation Observer
    const reviewMain = document.querySelector(".js-okeReviews-reviews-main");
    if (reviewMain) {
        const config = { childList: true };
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach((n) => setupReviews(n));
            }
        };
        const observer = new MutationObserver(callback, config);
        observer.observe(reviewMain, config);

        const reviews = document.querySelectorAll(".okeReviews-reviews-review");
        reviews.forEach((n) => setupReviews(n));
    };

}

function setupAggregate() {
    const reviewAggregateSummaryTotalContainer = document.querySelector('.okeReviews-reviewsAggregate-summary-total');
    if (reviewAggregateSummaryTotalContainer) {
        // Change Summary Total Text
        reviewAggregateSummaryTotalContainer.innerText = reviewAggregateSummaryTotalContainer.innerText.replace(/Based on/i, '');
    }
}

function moveWarButton() {
    const warButton = document.querySelector('.okeReviews-reviewsWidget-header-controls-writeReview:not(.is-okeReviews-hidden)');
    const reviewsControlsContainer = document.querySelector('.okeReviews-reviews-controls');
    if (warButton && reviewsControlsContainer) {
        // Move WAR Button next inside Reviews Controls Container
        reviewsControlsContainer.insertAdjacentElement('beforeend', warButton);
    }
}

function setupReviews(nodeElement) {
    if (nodeElement) {
        const reviewRecommendation = nodeElement.querySelector('.okeReviews-review-recommendation');
        const reviewMain = nodeElement.querySelector('.okeReviews-review-main');
        if (reviewRecommendation) {
            // move Recommendation to Review Content
            reviewMain.insertAdjacentElement('afterend', reviewRecommendation);
        }
    }
}